export default __webpack_public_path__ + "static/media/section2a-card3img.8e60af75.svg";